define('boxes/helpers/verification',['boxes/helpers/box-loading', 'boxes/events/bonus-event'], function(boxLoading, bonusEvent) {
    'use strict';

    function setupVerificationButtons($box, $controller, buttonHandlers) {
        var $verifyFrame = $box.find('.frame-row.verify');
        var $changeButton = $verifyFrame.find('.btn.change');
        var $changeFrame = $box.find('.frame.change');
        $changeButton.off('click').on('click', function (e) {
            e.preventDefault();
            $verifyFrame.hide();
            $changeFrame.show();
        });

        var $realChangeButton = $changeFrame.find('a');
        $realChangeButton.off('click').on('click', function(e) {
            e.preventDefault();
            boxLoading.showLoading($box);
            buttonHandlers.updateHandler($box, $changeFrame, $verifyFrame);
        });

        var $resendButton = $verifyFrame.find('.btn.resend');
        $resendButton.off('click').on('click', function(e) {
            e.preventDefault();
            boxLoading.showLoading($box);
            buttonHandlers.resendHandler($box);
        });
        var $verifyButton = $box.find('a.ui-button.verify');
        $verifyButton.off('click').on('click', function(e) {
            e.preventDefault();
            boxLoading.showLoading($box);
            buttonHandlers.verifyHandler($box, $controller);
        });

        var $skipBonusButton = $box.find('a.ui-button.skip');
        $skipBonusButton.off('click').on('click', function(e) {
            e.preventDefault();
            $(this).off();
            boxLoading.showLoading($box);
            $controller.trigger(bonusEvent.NO_SELECTED_BONUS);
            $controller.trigger(bonusEvent.RESET_VERIFICATION);
            $controller.nextBox();
        });
    }

    function resetChangeFrame($inputElement) {
        var $inputContainer = $inputElement.parent().parent();
        $inputContainer.removeClass('has-error');
        $inputContainer.popover('hide');
    }

    return {
        setupVerificationButtons: setupVerificationButtons,
        resetChangeFrame: resetChangeFrame
    };
});
